
define('text!templates/logout.html',[],function () { return '<div class="page-box-c layout logout-layout">\n\t<div class="page-body">\n\t\t<div class="w-box w-Logout">\n\t\t\t<h3>You have successfully logged out. </h3>\n\t\t</div>\n\t</div>\n</div>\n';});

